// extracted by mini-css-extract-plugin
var _1 = "_customClipLoader-module__black-border";
var _2 = "_customClipLoader-module__clip-loader";
var _3 = "_customClipLoader-module__spin";
export { _1 as "black-border", _2 as "clip-loader", _3 as "spin" }
